module.exports = __webpack_public_path__ + "media/apps/gif-android-5-firstframe-72717168.jpg";